import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { ArrowLeft, ShieldOff, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import BottomNav from '../components/BottomNav';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlockedUsers() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlocked();
  }, []);

  const fetchBlocked = async () => {
    try {
      const { data } = await axios.get(`${API}/blocks`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBlockedUsers(data.blocked_users);
    } catch (e) {
      console.error('Failed to fetch blocked users:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleUnblock = async (userId) => {
    try {
      await axios.delete(`${API}/block/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBlockedUsers(prev => prev.filter(u => u._id !== userId));
    } catch (e) {
      console.error('Failed to unblock:', e);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] pb-24">
      <header className="px-6 py-6 flex items-center gap-3">
        <button
          data-testid="back-btn"
          onClick={() => navigate('/app/settings')}
          className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:text-white"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="font-outfit text-2xl font-semibold text-white">Blocked Users</h1>
      </header>

      <main className="px-6">
        {loading && (
          <div className="flex justify-center py-10">
            <Loader2 className="w-8 h-8 text-rose-500 animate-spin" />
          </div>
        )}

        {!loading && blockedUsers.length === 0 && (
          <div className="text-center py-10">
            <p className="text-zinc-500">No blocked users</p>
          </div>
        )}

        {!loading && blockedUsers.length > 0 && (
          <div className="space-y-3">
            {blockedUsers.map((u) => (
              <div key={u._id} className="flex items-center justify-between p-4 rounded-xl bg-zinc-900/50 border border-zinc-800">
                <div className="flex items-center gap-3">
                  <img
                    src={u.photos?.[0] || 'https://images.unsplash.com/photo-1694877164163-bd51561f794a?w=80'}
                    alt={u.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <span className="text-white font-medium">{u.name}</span>
                </div>
                <Button
                  data-testid={`unblock-${u._id}`}
                  onClick={() => handleUnblock(u._id)}
                  variant="outline"
                  size="sm"
                  className="border-zinc-700 text-zinc-300 hover:bg-zinc-800"
                >
                  <ShieldOff className="w-4 h-4 mr-1" />
                  Unblock
                </Button>
              </div>
            ))}
          </div>
        )}
      </main>

      <BottomNav active="profile" />
    </div>
  );
}
